import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import { MediaBreakPointUp } from '@lean-body/components/styles';
import { useNavigate } from 'react-router-dom';
import { routes } from '@lean-body/src/route';
import { WebViewCallbackHandlers } from '@lean-body/src/interfaces';
import { GoalMatchingAssessmentResultButtons } from '../molecules/goal_matching_assessment_result_buttons';
export const GoalMatchingAssessmentEnableNotifications = ({ classObject, allowedNotificationPermission, }) => {
    const navigate = useNavigate();
    const onClickSkipNotificationPermissionButton = () => {
        navigate(routes.TOP.compile());
    };
    const onClickShowAllowNotificationPopup = () => {
        window.flutter_inappwebview
            .callHandler(WebViewCallbackHandlers.requestDeviceNotificationPermission)
            .then(({ result }) => {
            if (result) {
                allowedNotificationPermission();
            }
        });
    };
    return (React.createElement("div", { className: css(styles.result, classObject) },
        React.createElement("div", { className: css(styles.resultContent) },
            React.createElement("div", { className: css(styles.notificationDescription) },
                "\u6B21\u306E\u753B\u9762\u3067",
                React.createElement("br", null),
                "\u901A\u77E5\u3092\u30AA\u30F3\u306B\u3057\u3066\u4E09\u65E5\u574A\u4E3B\u3092\u514B\u670D\uFF01",
                React.createElement("br", null),
                "\u30EC\u30C3\u30B9\u30F3\u6642\u9593\u306B",
                React.createElement("br", null),
                "\u901A\u77E5\u3092\u53D7\u3051\u53D6\u308A\u307E\u3057\u3087\u3046\u3002"),
            React.createElement("img", { className: css(styles.notificationPopupGuideImg), src: "/assets/images/android_notification_permission_guide.png" })),
        React.createElement(GoalMatchingAssessmentResultButtons, { primaryText: "\u901A\u77E5\u3092\u53D7\u3051\u53D6\u308B", secondButtonText: "\u3042\u3068\u3067", onClickPrimary: onClickShowAllowNotificationPopup, onClickSecondButton: onClickSkipNotificationPermissionButton })));
};
const styles = StyleSheet.create({
    result: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        minHeight: '100%',
    },
    resultContent: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginBottom: 21,
        [MediaBreakPointUp.MD]: {
            width: 343,
        },
    },
    notificationDescription: {
        textAlign: 'center',
        fontWeight: 700,
        lineHeight: '160%',
        letterSpacing: 1.28,
    },
    notificationPopupGuideImg: {
        width: '100%',
        marginBottom: 50,
        [MediaBreakPointUp.SM]: {
            width: 343,
        },
    },
});
